import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Fade from '@material-ui/core/Fade';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { Product as ProductType } from '../../../../shared/contexts/AppContext';

interface ProductProps {
	product: ProductType;
	addProductToCart: (productId: number) => void;
}

const Product = (props: ProductProps) => {
	const { product, addProductToCart } = props;
	const { id, path, itemName, price, description } = product;

	return (
		<>
			<Fade in={true}>
				<Card sx={{ width: 345 }}>
					<CardHeader
						title={itemName}
						subheader={`PHP ${price}`}
						titleTypographyProps={{ variant: 'h6' }}
						action={
							<IconButton
								aria-label='Add To Cart'
								onClick={() => addProductToCart(id)}
							>
								<AddOutlinedIcon />
							</IconButton>
						}
					/>
					<CardMedia component='img' height='194' image={path} alt={itemName} />
					<CardContent>
						<Typography variant='body2' color='text.secondary'>
							{description}
						</Typography>
					</CardContent>
				</Card>
			</Fade>
		</>
	);
};

export default Product;
